/** Símbolo oficial de Google Analytics con sus colores de marca. */
export function GoogleAnalyticsMark({ size = 18 }: { size?: number }) {
  return (
    <svg
      className="dash-brand-mark dash-google-analytics-mark"
      width={size}
      height={size}
      viewBox="0 0 26 24"
      fill="none"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M25.7 2.85v18.3a2.85 2.85 0 0 1-5.7 0V2.85a2.85 2.85 0 0 1 5.7 0Z" fill="#F9AB00" />
      <path d="M15.7 11.4v9.75a2.85 2.85 0 0 1-5.7 0V11.4a2.85 2.85 0 0 1 5.7 0Z" fill="#E37400" />
      <circle cx="2.85" cy="21.15" r="2.85" fill="#E37400" />
    </svg>
  )
}
